import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-screen-banner',
  imports: [],
  templateUrl: './screen-banner.component.html',
  styleUrl: './screen-banner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenBannerComponent {}
